export default `
§ page.settings.document.title: Anzeigeeinstellungen
§ page.settings.document.name: Seitentitel
§ page.settings.document.language: Sprache der benutzeroberfläche
§ page.settings.document.depersonalize: Persönliche daten verstecken
§ page.settings.links.title: Link-Präfixe
§ page.settings.links.task: Für Aufgabennummern
§ page.settings.links.pr: Für PR
§ page.settings.user.title: Individuelle einstellungen
§ page.settings.user.notFound: Keine individuellen Einstellungen. Daten für alle Mitarbeiter werden anhand allgemeiner Parameter berechnet.
§ page.settings.user.subTitle: Zusatz zum arbeitsvertrag №. $1
§ page.settings.user.from: Startdatum
§ page.settings.mailmap: Beispiel .mailmap
§ page.settings.common.title: Allgemeine Gehaltsdaten
§ page.settings.common.type.title: Art der projektarbeit
§ page.settings.common.type.full: Vollzeitbeschäftigung
§ page.settings.common.type.part: Projektarbeit
§ page.settings.common.salary: Monatliches gehalt in USD (US-Dollar, $)
§ page.settings.common.currency: Währung zur ansicht
§ page.settings.common.workDaysInYear: Anzahl der arbeitstage im Jahr
§ page.settings.common.vacationDaysInYear: Anzahl der urlaubstage im Jahr
§ page.settings.common.workDaysInWeek: Arbeitstage
§ page.settings.form.save: Speichern
§ page.settings.form.cancel: Abbrechen
§ page.settings.form.remove: Entfernen
§ page.settings.form.addEmployee: Mitarbeiter hinzufügen
§ page.settings.form.addContract: Arbeitsvertrag hinzufügen
`;
